module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "links-wrapper"
  }, [_vm._l((_vm.links), function(link) {
    return [_c('FooterLink', {
      key: link.title,
      attrs: {
        "title": link.title,
        "icon": link.icon,
        "url": link.url
      }
    })]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("All text and design is copyright " + _vm._s(_vm.year) + " 25sprout, LLC. All rights reserved.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-49d419f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 674
// module chunks = 0